import { dispatch } from '@ngxs/store';
import { NotificationsActions } from './notifications.actions';
import * as i0 from "@angular/core";
export let NotificationsFacade = /*#__PURE__*/(() => {
  class NotificationsFacade {
    constructor() {
      this.reloadCount = dispatch(NotificationsActions.ReloadCount);
      this.fetch = dispatch(NotificationsActions.Fetch);
      this.fetchMore = dispatch(NotificationsActions.FetchMore);
      this.stopFetching = dispatch(NotificationsActions.StopFetching);
      this.reloadNotifications = dispatch(NotificationsActions.ReloadNotifications);
      this.deleteNotification = dispatch(NotificationsActions.DeleteNotification);
      this.toggleReadNotification = dispatch(NotificationsActions.ToggleReadNotification);
    }
    static {
      this.ɵfac = function NotificationsFacade_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || NotificationsFacade)();
      };
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: NotificationsFacade,
        factory: NotificationsFacade.ɵfac
      });
    }
  }
  return NotificationsFacade;
})();